<template lang="html">
  <div class="page-site-appearance tier tier-two">
    <Tooltip content="Manage the look and feel of your website by updating your sites theme, colours and fonts"/>

    <ul class="tier-list tier-content">
      <Permissions
        tag="li"
        class="tier-list-item"
        v-for="(item, index) in items"
        :key="`item-${index}`"
        :permissions="currentUser.permissions"
        :requireAll="item.permission">

        <router-link :to="item.link">
          <div>
            <Sprite :name="item.slug"/>
          </div>
          <span>{{item.name}}</span>
        </router-link>

      </Permissions>
    </ul>

    <transition name="column-left">
      <router-view @updatePage="updatePage" :activeMode="activeMode"/>
    </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import Sprite from '@/components/Sprite'
import Tooltip from '@/components/Tooltip'
import Permissions from '@/components/Permissions'

export default {
  name: 'SiteAppearanceList',

  props: {
    companyId: String,
    siteId: String,
    activeMode: String
  },

  data() {
    return {
      items: [
        {
          name: 'Site Theme',
          slug: 'theme',
          link: {
            name: 'theme-settings',
            params: {
              companyId: this.companyId,
              siteId: this.siteId
            }
          },
          permission: {
            theme: ['list']
          }
        },
        {
          name: 'Colour Palette',
          slug: 'pallette',
          link: {
            name: 'colour-palette',
            params: {
              companyId: this.companyId,
              siteId: this.siteId
            }
          },
          permission: {
            theme: ['list']
          }
        },
        {
          name: 'Fonts',
          slug: 'fonts',
          link: {
            name: 'fonts',
            params: {
              companyId: this.companyId,
              siteId: this.siteId
            }
          }
        },
        {
          name: 'Custom CSS',
          description: 'Edit your sites CSS',
          slug: 'advanced',
          link: {
            name: 'custom-css-settings',
            params: {
              companyId: this.companyId,
              siteId: this.siteId
            }
          }
        }
      ]
    }
  },

  components: {
    Sprite,
    Tooltip,
    Permissions
  },

  methods: {
    updatePage(notification) {
      this.$emit('updatePage', notification)
    }
  },

  computed: {
    ...mapState(['currentUser'])
  }
}
</script>

<style lang="sass">
  .page-site-appearance
    box-shadow: inset -30px 0px 30px 0px rgba(0, 0, 0, 0.05)
</style>
